import { Card, AspectRatio, Image } from "@mantine/core"
import { useChatPostAttachmentApi } from "../../../../../../attachment-api/chatPostAttachmentApi"
import { ChatPostAttachmentDto } from "../../../../../../@client/Theasoft_ApiServer_Chat"

export function PostAttachments({
  attachments,
  chatPostId,
}: {
  attachments: ChatPostAttachmentDto[]
  chatPostId: number
}) {
  const chatPostAttachmentAPI = useChatPostAttachmentApi()

  return (
    <Card.Section>
      <AspectRatio w="100%" ratio={16 / 9}>
        <Image
          w="100%"
          fit="contain"
          src={chatPostAttachmentAPI.getFileUrl(
            attachments[0].attachmentId,
            chatPostId
          )}
          alt="Feed post"
        />
      </AspectRatio>
    </Card.Section>
  )
}
